{
  "name": "rainlink",
  "version": "1.2.9",
  "description": "Another lavalink wrapper but focus on stability and rich features",
  "repository": {
    "type": "git",
    "url": "https://github.com/DeepinRain/Rainlink.git"
  },
  "scripts": {
    "build": "npx tsup-node",
    "prettier": "npx prettier -w ./src",
    "build:doc": "typedoc --options ./typedoc.json --sort kind",
    "build:full": "npm run prettier && npm run build:eslint && npm run build && npm run build:doc",
    "build:eslint": "npx eslint ./src --fix"
  },
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    }
  },
  "keywords": [
    "bot",
    "music",
    "lavalink.js",
    "lavalink-api",
    "discord.js",
    "eris.js",
    "oceanic.js",
    "lavalink",
    "wrapper",
    "lavalink-wrapper",
    "rainlink",
    "bun"
  ],
  "author": "RainyXeon",
  "license": "GPL-3.0",
  "devDependencies": {
    "@types/bun": "^1.3.9",
    "@types/node": "^25.3.0",
    "@types/node-fetch": "^2.6.13",
    "@types/ws": "^8.18.1",
    "dotenv": "^17.3.1",
    "prettier": "^3.8.1",
    "tsup": "^8.5.1",
    "typedoc": "^0.28.17",
    "typescript": "^5.9.3"
  },
  "tsup": {
    "dts": true,
    "entry": [
      "./src/index.ts"
    ],
    "splitting": false,
    "sourcemap": true,
    "clean": true,
    "format": [
      "cjs",
      "esm"
    ]
  },
  "prettier": {
    "trailingComma": "es5",
    "tabWidth": 2,
    "semi": false,
    "singleQuote": true,
    "printWidth": 100
  },
  "dependencies": {
    "ws": "^8.19.0"
  }
}
